(()=>{
 const start=Date.parse('2026-10-15T00:00:00-04:00'),end=Date.parse('2026-11-02T00:00:00-05:00');
 const earlyEnd=Date.parse('2026-10-21T00:00:00-04:00'),courseEnd=Date.parse('2026-10-25T00:00:00-04:00');
 const phase=now=>now<start?'before_one':now<end?'one':'off';
 const coursePhase=now=>now<earlyEnd?'early':now<courseEnd?'regular':'over';
 let timer;
 function update(){
  const now=Date.now(),current=phase(now),course=coursePhase(now);
  document.querySelectorAll('[data-ww-sale-phase]').forEach(n=>{if(n.dataset.wwSalePhase!==current)n.dataset.wwSalePhase=current;});
  document.querySelectorAll('[data-ww-sale-regular]').forEach(n=>{if(n.dataset.wwSaleRegular!==current)n.dataset.wwSaleRegular=current;});
  document.querySelectorAll('[data-ww-course-phase]').forEach(n=>{if(n.dataset.wwCoursePhase!==course)n.dataset.wwCoursePhase=course;});
  document.querySelectorAll('[data-ww-course-regular]').forEach(n=>{if(n.dataset.wwCourseRegular!==course)n.dataset.wwCourseRegular=course;});
 }
 function schedule(){clearTimeout(timer);update();const now=Date.now();const next=[start,end,earlyEnd,courseEnd].filter(n=>n>now).sort((a,b)=>a-b)[0];timer=setTimeout(schedule,next?Math.min(60000,Math.max(50,next-now+25)):60000);}
 schedule();document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
 document.addEventListener('shopify:section:load',update);
 const main=document.getElementById('MainContent');if(main)new MutationObserver(update).observe(main,{childList:true,subtree:true});
})();
